import { t } from "@travily/i18n";
import individualIllustration from "@ui/assets/illustrations/individual-animated.webp";
import { NumberStepper } from "@ui/components/NumberStepper";
import { Wizard } from "@ui/components/Wizard";
import type { ReactNode } from "react";

const COLOR = "purple" as const;

export interface ExperienceStepViewProps {
  currentStage: number;
  totalStages: number;
  onBack?: () => void;
  /** Wizard top-bar tertiary actions (Questions / Save and finish later). */
  topBarActions: ReactNode;
  isPending: boolean;
  value: number;
  error?: string;
  onChange: (value: number) => void;
  onContinue: () => void;
}

export function ExperienceStepView({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  isPending,
  value,
  error,
  onChange,
  onContinue,
}: ExperienceStepViewProps) {
  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onContinue} isPending={isPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={individualIllustration} />}
        heading={t("web.founding_members.creator.steps.individual.experience.show.title")}
      >
        <NumberStepper
          aria-label={t("web.founding_members.creator.steps.individual.experience.show.aria_label")}
          errorMessage={error}
          isInvalid={error != null}
          max={99}
          min={1}
          onChange={onChange}
          unit={t("web.founding_members.creator.steps.individual.experience.show.unit")}
          value={value}
        />
      </Wizard.Stage>
    </Wizard>
  );
}
